<template>
  <v-flex d-block xs12>
    <v-card>
      <v-card-title>
        <h3 style="display: inline-block;">Specialists</h3>
        <v-spacer></v-spacer>
      </v-card-title>

      <table class="v-table table-striped theme--light">
        <thead>
        <tr>
          <th class="column text-xs-left">Name</th>
          <th class="column text-xs-left">Position</th>
          <th class="column text-xs-left">Phone</th>
          <th class="column text-xs-left">Email</th>
          <th class="column text-xs-left">Comment</th>
          <th class="column text-xs-left">External Id</th>
          <th class="column text-xs-left">Invite to DP cases</th>
          <th class="column text-xs-left">Role</th>
          <th></th>
        </tr>
        <tr class="v-datatable__progress" v-show="processing">
          <th colspan="6" class="column">
            <template>
              <v-progress-linear height="2" color="primary" :indeterminate="true"></v-progress-linear>
            </template>
          </th>
        </tr>
        </thead>
        <tbody>
        <specialist-item v-for="specialist in items"
                     v-bind:key="specialist.id"
                     v-bind:item="specialist"
                     :availableSpecialistRole="availableSpecialistRole"
                     @updated="handleSpecialistUpdatedEvent"
                     @deleted="handleSpecialistDeletedEvent"
                     @startProcessing="handleStartProcessing"
                     @stopProcessing="handleStopProcessing">
        </specialist-item>
        </tbody>
      </table>
      <v-container fluid>
        <v-layout v-bind:style="{'display': 'inline-block', 'width': '100%'}">
          <v-flex d-block xs6 v-if="createSpecialistFormVisible">
            <specialist-creation-form :clientId="clientId"
                                      :visible="createSpecialistFormVisible"
                                      :availableSpecialistRole="availableSpecialistRole"
                                      @created="handleCreationFormCreatedEvent"
                                      @close="handleCreationFormCloseEvent"
            ></specialist-creation-form>
          </v-flex>
          <v-btn color="success" v-if="!createSpecialistFormVisible" @click="handleClickCreateSpecialistButton">Create specialist</v-btn>
        </v-layout>
      </v-container>
    </v-card>
  </v-flex>
</template>

<script>
import SpecialistCreationForm from './SpecialistCreationForm'
import SpecialistItem from './SpecialistItem'

export default {
  name: 'specialists',
  components: {
    SpecialistCreationForm,
    SpecialistItem
  },
  props: {
    items: {
      type: Array
    },
    clientId: {
      type: String
    },
    availableSpecialistRole: {
      type: Array
    }
  },
  data () {
    return {
      processing: false,
      loading: false,
      createSpecialistFormVisible: false
    }
  },
  methods: {
    handleClickCreateSpecialistButton () {
      this.createSpecialistFormVisible = !this.createSpecialistFormVisible
    },
    handleCreationFormCreatedEvent (createdSpecialist) {
      this.createSpecialistFormVisible = false
      this.$emit('specialistCreated', createdSpecialist)
    },
    handleCreationFormCloseEvent () {
      this.createSpecialistFormVisible = false
    },
    handleSpecialistUpdatedEvent (updatedSpecialist) {
      this.$emit('specialistUpdated', updatedSpecialist)
    },
    handleSpecialistDeletedEvent (deletedSpecialist) {
      this.$emit('specialistDeleted', deletedSpecialist)
    },
    handleStartProcessing () {
      this.processing = true
    },
    handleStopProcessing () {
      this.processing = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/Specialists.vue